
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as scannerTQA59asAahn_45MJ8aNI4nKKQMkPd2fVF7ot8x2L_0dzIMeta } from "/opt/buildhome/repo/pages/scanner.vue?macro=true";
import { default as error_45testOEmOcYaF4kj_LsqtXs_dxfDdbWQufjPbG8nPCvGMjykMeta } from "/opt/buildhome/repo/pages/error-test.vue?macro=true";
import { default as index_45wNNtyay7UZ_QpKMEb_459kPEHNjLS1i_5Q5_45cwzS1S0cMeta } from "/opt/buildhome/repo/pages/rope-admin/index.vue?macro=true";
import { default as loginv5uRwrgJp4_45ZdRd2f2i1zy_45ZFTO7hu5t_Z7U_459Q43ZIMeta } from "/opt/buildhome/repo/pages/rope-admin/login.vue?macro=true";
import { default as indexdTpFtUVE02vbFk1sz5toIPuXifhJdWMAGVjuIl98MG4Meta } from "/opt/buildhome/repo/pages/registration/index.vue?macro=true";
import { default as connectX7icyzL_LhE_jXUMqP9yh6VMX1bNhyfZFMCEKEJgENIMeta } from "/opt/buildhome/repo/pages/rope-admin/connect.vue?macro=true";
import { default as supportedTwVPUryXm1yaKz11E_45uSX7bQjFjmTNLPHwThpHmyHzIMeta } from "/opt/buildhome/repo/pages/rope-admin/supported.vue?macro=true";
import { default as person_45listNub4oSczazl22GWXayj_n2hTYybPjQx8tRXYZ0S4PDYMeta } from "/opt/buildhome/repo/pages/rope-admin/person-list.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "scanner",
    path: "/scanner",
    meta: scannerTQA59asAahn_45MJ8aNI4nKKQMkPd2fVF7ot8x2L_0dzIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/scanner.vue")
  },
  {
    name: "error-test",
    path: "/error-test",
    component: () => import("/opt/buildhome/repo/pages/error-test.vue")
  },
  {
    name: "rope-admin",
    path: "/rope-admin",
    component: () => import("/opt/buildhome/repo/pages/rope-admin/index.vue")
  },
  {
    name: "rope-admin-login",
    path: "/rope-admin/login",
    component: () => import("/opt/buildhome/repo/pages/rope-admin/login.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/opt/buildhome/repo/pages/registration/index.vue")
  },
  {
    name: "rope-admin-connect",
    path: "/rope-admin/connect",
    component: () => import("/opt/buildhome/repo/pages/rope-admin/connect.vue")
  },
  {
    name: "rope-admin-supported",
    path: "/rope-admin/supported",
    component: () => import("/opt/buildhome/repo/pages/rope-admin/supported.vue")
  },
  {
    name: "rope-admin-person-list",
    path: "/rope-admin/person-list",
    component: () => import("/opt/buildhome/repo/pages/rope-admin/person-list.vue")
  }
]